var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card-actions",
        {
          attrs: { "no-actions": "", "show-loading": _vm.loading || _vm.busy },
        },
        [
          _c(
            "div",
            { staticClass: "d-flex align-items-center" },
            [
              _c("feather-icon", {
                staticClass: "mr-1 text-primary",
                attrs: {
                  icon: _vm.scope === "general" ? "GlobeIcon" : "HomeIcon",
                  size: "22",
                },
              }),
              _c("div", [
                _c("h5", { staticClass: "mb-0" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("Campanhas de frete")) +
                      " — " +
                      _vm._s(_vm.scopeTitle) +
                      " "
                  ),
                ]),
                _c("small", { staticClass: "text-muted" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "Campanhas são temporárias: valem só no período informado e substituem a configuração base nesse período."
                        )
                      ) +
                      " "
                  ),
                ]),
              ]),
            ],
            1
          ),
        ]
      ),
      !_vm.editing
        ? _c(
            "b-card-actions",
            {
              attrs: {
                "no-actions": "",
                "show-loading": _vm.loading || _vm.busy,
              },
            },
            [
              _c(
                "b-row",
                { staticClass: "mb-1", attrs: { "align-v": "center" } },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "delivery-campaign-include-expired",
                          type: "switch",
                          name: "includeExpired",
                          label: _vm.$t("Incluir campanhas expiradas"),
                        },
                        model: {
                          value: _vm.includeExpiredModel,
                          callback: function ($$v) {
                            _vm.includeExpiredModel = $$v
                          },
                          expression: "includeExpiredModel",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { staticClass: "text-right" },
                    [
                      _c("e-button", {
                        attrs: {
                          variant: "outline-primary",
                          icon: "plus",
                          text: _vm.$t("Nova campanha"),
                        },
                        on: { click: _vm.newCampaign },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("b-table", {
                staticClass: "table-responsive bordered",
                attrs: {
                  id: "delivery-campaigns-table",
                  responsive: "",
                  striped: "",
                  "show-empty": "",
                  "empty-text": _vm.$t(
                    "Nenhuma campanha cadastrada para este escopo."
                  ),
                  items: _vm.campaignConfigs,
                  fields: _vm.fields,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "cell(actions)",
                      fn: function (row) {
                        return [
                          _c("e-grid-actions", {
                            attrs: {
                              "show-update": _vm.$can("Update", "Store"),
                              "show-delete": _vm.$can("Update", "Store"),
                            },
                            on: {
                              update: function ($event) {
                                return _vm.editCampaign(row.item)
                              },
                              delete: function ($event) {
                                return _vm.deleteCampaign(row.item)
                              },
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: "cell(period)",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _vm._v(
                            " " +
                              _vm._s(_vm.formatDate(item.effectiveFrom)) +
                              " → " +
                              _vm._s(_vm.formatDate(item.effectiveTo)) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "cell(active)",
                      fn: function (ref) {
                        var value = ref.value
                        return [
                          _c(
                            "b-badge",
                            {
                              attrs: {
                                variant: value
                                  ? "light-success"
                                  : "light-secondary",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    value ? _vm.$t("Ativa") : _vm.$t("Inativa")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  907646827
                ),
              }),
            ],
            1
          )
        : _c(
            "FormulateForm",
            { ref: "form", attrs: { name: "formDeliveryCampaign" } },
            [
              _c(
                "b-card-actions",
                {
                  attrs: {
                    "no-actions": "",
                    "show-loading": _vm.loading || _vm.busy,
                  },
                },
                [
                  _c("h5", { staticClass: "mb-1" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.isNew
                            ? _vm.$t("Nova campanha")
                            : _vm.$t("Editar campanha")
                        ) +
                        " "
                    ),
                  ]),
                  _c(
                    "b-alert",
                    {
                      staticClass: "mb-1",
                      attrs: { variant: "info", show: "" },
                    },
                    [
                      _c("div", { staticClass: "alert-body" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "O período de início e fim é obrigatório. Maior prioridade vence quando duas campanhas coincidem no mesmo período."
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "3" } },
                        [
                          _c("FormulateInput", {
                            staticClass: "required",
                            attrs: {
                              id: "delivery-campaign-from",
                              type: "datepicker",
                              name: "effectiveFrom",
                              validation: "required",
                              label: _vm.$t("Vigente de"),
                            },
                            model: {
                              value: _vm.config.effectiveFrom,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "effectiveFrom", $$v)
                              },
                              expression: "config.effectiveFrom",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "3" } },
                        [
                          _c("FormulateInput", {
                            staticClass: "required",
                            attrs: {
                              id: "delivery-campaign-to",
                              type: "datepicker",
                              name: "effectiveTo",
                              validation: "required",
                              label: _vm.$t("Vigente até"),
                            },
                            model: {
                              value: _vm.config.effectiveTo,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "effectiveTo", $$v)
                              },
                              expression: "config.effectiveTo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "3" } },
                        [
                          _c("FormulateInput", {
                            staticClass: "required",
                            attrs: {
                              id: "delivery-campaign-priority",
                              type: "text-number",
                              precision: 0,
                              name: "priority",
                              validation: "required|min:1",
                              label: _vm.$t("Prioridade"),
                            },
                            model: {
                              value: _vm.config.priority,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "priority", $$v)
                              },
                              expression: "config.priority",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "3" } },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "delivery-campaign-active",
                              type: "switch",
                              name: "active",
                              label: _vm.$t("Campanha ativa"),
                            },
                            model: {
                              value: _vm.config.active,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "active", $$v)
                              },
                              expression: "config.active",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-card-actions",
                {
                  attrs: {
                    "no-actions": "",
                    "show-loading": _vm.loading || _vm.busy,
                  },
                },
                [
                  _c(
                    "b-tabs",
                    [
                      _c(
                        "b-tab",
                        {
                          attrs: {
                            title: _vm.$t("Valores da campanha"),
                            active: "",
                          },
                        },
                        [
                          _c("delivery-config-defaults", {
                            attrs: { config: _vm.config },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-tab",
                        {
                          attrs: { title: _vm.$t("Ajustes por dia da semana") },
                        },
                        [
                          _c("delivery-config-by-day", {
                            attrs: { config: _vm.config },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
      _vm.editing
        ? _c("FAB", {
            attrs: {
              "main-tooltip": _vm.$t("Ações"),
              "main-icon": "keyboard_command_key",
              actions: _vm.editorActions,
              "fixed-tooltip": true,
              busy: _vm.busy,
            },
            on: { save: _vm.saveCampaign, cancel: _vm.cancelEdit },
          })
        : _c("FAB", {
            attrs: {
              "main-tooltip": _vm.$t("Voltar para a listagem"),
              "main-icon": "arrow_back",
            },
            on: { click: _vm.goToList },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }